export const PRO_CHAT_CHANNEL_STORAGE_KEY = 'glow_pro_chat_channel';

export const getAvailableProChatChannels = ({
  user,
  hasClientPermission = false,
  hasSupportPermission = false,
}) => {
  if (!user) return [];
  if (['admin', 'superadmin'].includes(user.role)) return ['support'];

  return [
    ...(hasClientPermission ? ['clients'] : []),
    ...(hasSupportPermission ? ['support'] : []),
  ];
};

export const resolveProChatChannel = (channels, storedChannel) => {
  if (storedChannel && channels.includes(storedChannel)) {
    return storedChannel;
  }
  if (channels.includes('clients')) return 'clients';
  return channels[0] || null;
};
